
import React, { useEffect, useState } from 'react';
import { Check, CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { supabase } from '@/integrations/supabase/client';

const FormCompleted: React.FC = () => {  
  return <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-sm border border-gray-100">
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mb-6">
          <CheckCircle className="h-12 w-12 text-green-600" />
        </div>
        <h2 className="text-3xl font-bold text-brand-basic mb-4">Submission Successful!</h2>
        <p className="text-gray-600 max-w-md mb-8">
          Thank you for submitting your information. Our team will review your details and get back to you shortly.
        </p>
        
        <div className="w-full max-w-md mb-8 bg-gray-50 rounded-lg p-6 border border-gray-200">
          <h3 className="text-lg font-medium text-brand-basic mb-4">What happens next?</h3>
          <ul className="space-y-4">
            <li className="flex items-start py-0">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-brand-primary bg-opacity-10 flex items-center justify-center mr-3 mt-0.5">
                <Check className="h-3.5 w-3.5 text-brand-primary" />
              </div>
              <p className="text-gray-600 text-sm my-[4px]">Our team will review your submission</p>
            </li>
            <li className="flex items-start">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-brand-primary bg-opacity-10 flex items-center justify-center mr-3 mt-0.5">
                <Check className="h-3.5 w-3.5 text-brand-primary" />
              </div>
              <p className="text-gray-600 text-sm my-[4px]">We'll contact you regarding next steps</p>
            </li>
          </ul>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <Button onClick={() => window.location.href = '/step/1'} variant="outline" className="flex items-center gap-2">
            Start New Application
          </Button>
          
        </div>
      </div>
    </div>;
};

export default FormCompleted;
